import {IconMenu2} from "@tabler/icons-react";
import {Grid} from "@ui";
import {theme} from "antd";
import {useCallback, useEffect, useState} from "react";

import {useNavigate} from "react-router-dom";
import CustomNavbar from "../../../components/CustomNavbar";
import {MenuVertical} from "./arrayMenu";

const {useToken} = theme;

const BaseMenu = () => {
  const {token} = useToken();
  const {useBreakpoint} = Grid;
  const screens = useBreakpoint();
  const navigate = useNavigate();
  const [current] = useState("projects");

  // Add responsive state
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const widthTabletView = 800;
  const widthResponsive = 1199;

  // Add resize listener
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const menuVertical = MenuVertical();

  const styles = {
    menu: {
      backgroundColor: "transparent",
      borderBottom: "none",
      lineHeight: screens.sm ? "6rem" : "3.5rem",
      marginLeft: screens.xl ? "0px" : `-${token?.size}px`,
      marginRight: screens.xl ? "0px" : "10px",
      width: screens.xl ? "inherit" : token.sizeXXL,
      // paddingTop: screens.xl ? "0" : "1rem",
    },
    menuContainer: {
      alignItems: "center",
      display: "flex",
      gap: token?.size,
      width: "100%",
    },
  };

  const selected = location.pathname.replace(/\/dashboard\/?/, "") || "index";
  const open = selected.split("/")[0];

  const onSelect = useCallback(
    item => {
      if (item.onClick) {
        item.onClick();
        return;
      }
      const {key} = item;
      navigate(key);
    },
    [navigate]
  );

  // console.log("Menu");

  // Only show the hamburger menu between 800px and 1199px
  if (windowWidth < widthTabletView || windowWidth > widthResponsive) {
    return null;
  }

  return (
    <CustomNavbar
      items={menuVertical}
      onSelect={onSelect}
      mode="horizontal"
      style={styles.menu}
      selectedKeys={screens.xl ? [current] : []}
      defaultOpenKeys={[open]}
      overflowedIndicator={
        <span
          style={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            width: 40,
            height: 40,
            color: "var(--text-primary)",
            fontSize: 25,
            background: "transparent",
            border: "none",
            cursor: "pointer",
            marginRight: "20px",
          }}
        >
          <IconMenu2
            size={24}
            stroke={2}
            color="white"
          />
        </span>
      }
    />
  );
};

// Export the updateMenuProps function along with the component
export default BaseMenu;
